import type { SprintStatesCategories } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/dependencies/types.tsx';
import type { Sprint } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/sprints/types.tsx';

export type OwnProps = {
	setSprintFilter: (sprintIds: string[]) => void;
	onFilterChange: () => void;
	isOpen?: boolean;
};

export type StateProps = {
	externalSprints: Sprint[];
	sprintsAndTeams: {
		sprintsWithTeams: {
			sprints: Sprint[];
			teams: string[];
		}[];
		sprintsWithoutTeams: Sprint[];
	};
	sprintFilter: Set<string>;
	sprintStatesCategories: SprintStatesCategories[];
};

export type Props = OwnProps & StateProps;

export const STATE_CATEGORY = 'STATE_CATEGORY';
